'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind from "./presto.types$-Grouping-Kind.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind$0024$0024anon$002416 from "./presto.types$-Grouping-Kind$$anon$16.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingKind$$anon$19(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$GroupingKind$$anon$19 as $c_Lpresto_types$GroupingKind$$anon$19 };
$p = $c_Lpresto_types$GroupingKind$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingKind$$anon$19;
/** @constructor */
function $h_Lpresto_types$GroupingKind$$anon$19() {
}
export { $h_Lpresto_types$GroupingKind$$anon$19 as $h_Lpresto_types$GroupingKind$$anon$19 };
$h_Lpresto_types$GroupingKind$$anon$19.prototype = $p;
$p.bN = (function(text) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$GroupingKind$().cwD(text));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.cAW = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it.l());
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bJ = (function(t) {
  return this.cAW(t);
});
var $d_Lpresto_types$GroupingKind$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingKind$$anon$19, "presto.types$GroupingKind$$anon$19", ({
  a0n: 1,
  K: 1
}));
export { $d_Lpresto_types$GroupingKind$$anon$19 as $d_Lpresto_types$GroupingKind$$anon$19 };
function $s_Lpresto_types$GroupingKind$__intimacao__Lpresto_types$GroupingKind() {
  $m_Lpresto_types$GroupingKind$();
  return $t_Lpresto_types$GroupingKind$__intimacao;
}
export { $s_Lpresto_types$GroupingKind$__intimacao__Lpresto_types$GroupingKind as $s_Lpresto_types$GroupingKind$__intimacao__Lpresto_types$GroupingKind };
function $s_Lpresto_types$GroupingKind$__movimentacao__Lpresto_types$GroupingKind() {
  $m_Lpresto_types$GroupingKind$();
  return $t_Lpresto_types$GroupingKind$__movimentacao;
}
export { $s_Lpresto_types$GroupingKind$__movimentacao__Lpresto_types$GroupingKind as $s_Lpresto_types$GroupingKind$__movimentacao__Lpresto_types$GroupingKind };
function $s_Lpresto_types$GroupingKind$__protocolo__Lpresto_types$GroupingKind() {
  $m_Lpresto_types$GroupingKind$();
  return $t_Lpresto_types$GroupingKind$__protocolo;
}
export { $s_Lpresto_types$GroupingKind$__protocolo__Lpresto_types$GroupingKind as $s_Lpresto_types$GroupingKind$__protocolo__Lpresto_types$GroupingKind };
function $s_Lpresto_types$GroupingKind$__copia__Lpresto_types$GroupingKind() {
  $m_Lpresto_types$GroupingKind$();
  return $t_Lpresto_types$GroupingKind$__copia;
}
export { $s_Lpresto_types$GroupingKind$__copia__Lpresto_types$GroupingKind as $s_Lpresto_types$GroupingKind$__copia__Lpresto_types$GroupingKind };
/** @constructor */
function $c_Lpresto_types$GroupingKind$() {
  this.c7p = null;
  this.c7s = null;
  this.c7t = false;
  this.c7q = null;
  this.c7r = false;
  this.c7u = null;
  this.c7v = false;
  this.c7w = null;
  this.c7x = false;
  $n_Lpresto_types$GroupingKind$ = this;
  $t_Lpresto_types$GroupingKind$__intimacao = new $j_presto$002etypes$0024$002dGrouping$002dKind$0024$0024anon$002416.$c_Lpresto_types$GroupingKind$$anon$16(0, "intimacao", this);
  $t_Lpresto_types$GroupingKind$__movimentacao = new $j_presto$002etypes$0024$002dGrouping$002dKind$0024$0024anon$002416.$c_Lpresto_types$GroupingKind$$anon$16(1, "movimentacao", this);
  $t_Lpresto_types$GroupingKind$__protocolo = new $j_presto$002etypes$0024$002dGrouping$002dKind$0024$0024anon$002416.$c_Lpresto_types$GroupingKind$$anon$16(2, "protocolo", this);
  $t_Lpresto_types$GroupingKind$__copia = new $j_presto$002etypes$0024$002dGrouping$002dKind$0024$0024anon$002416.$c_Lpresto_types$GroupingKind$$anon$16(3, "copia", this);
  this.c7p = new ($j_presto$002etypes$0024$002dGrouping$002dKind.$d_Lpresto_types$GroupingKind.r().C)([$s_Lpresto_types$GroupingKind$__intimacao__Lpresto_types$GroupingKind(), $s_Lpresto_types$GroupingKind$__movimentacao__Lpresto_types$GroupingKind(), $s_Lpresto_types$GroupingKind$__protocolo__Lpresto_types$GroupingKind(), $s_Lpresto_types$GroupingKind$__copia__Lpresto_types$GroupingKind()]);
}
export { $c_Lpresto_types$GroupingKind$ as $c_Lpresto_types$GroupingKind$ };
$p = $c_Lpresto_types$GroupingKind$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingKind$;
/** @constructor */
function $h_Lpresto_types$GroupingKind$() {
}
export { $h_Lpresto_types$GroupingKind$ as $h_Lpresto_types$GroupingKind$ };
$h_Lpresto_types$GroupingKind$.prototype = $p;
$p.cRi = (function() {
  return this.c7p.as();
});
$p.cwD = (function(\u03b4name) {
  switch (\u03b4name) {
    case "intimacao": {
      return $s_Lpresto_types$GroupingKind$__intimacao__Lpresto_types$GroupingKind();
      break;
    }
    case "movimentacao": {
      return $s_Lpresto_types$GroupingKind$__movimentacao__Lpresto_types$GroupingKind();
      break;
    }
    case "protocolo": {
      return $s_Lpresto_types$GroupingKind$__protocolo__Lpresto_types$GroupingKind();
      break;
    }
    case "copia": {
      return $s_Lpresto_types$GroupingKind$__copia__Lpresto_types$GroupingKind();
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
    }
  }
});
$p.cIe = (function() {
  if ((!this.c7t)) {
    this.c7s = new $c_Lpresto_types$GroupingKind$$anon$17(this);
    this.c7t = true;
  }
  return this.c7s;
});
$p.p4 = (function() {
  if ((!this.c7r)) {
    this.c7q = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$GroupingKind$().cwD(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa);
    this.c7r = true;
  }
  return this.c7q;
});
$p.cIE = (function() {
  if ((!this.c7v)) {
    this.c7u = new $c_Lpresto_types$GroupingKind$$anon$18(this);
    this.c7v = true;
  }
  return this.c7u;
});
$p.csv = (function() {
  if ((!this.c7x)) {
    this.c7w = new $c_Lpresto_types$GroupingKind$$anon$19(this);
    this.c7x = true;
  }
  return this.c7w;
});
var $d_Lpresto_types$GroupingKind$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingKind$, "presto.types$GroupingKind$", ({
  a0j: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$GroupingKind$ as $d_Lpresto_types$GroupingKind$ };
var $n_Lpresto_types$GroupingKind$;
function $m_Lpresto_types$GroupingKind$() {
  if ((!$n_Lpresto_types$GroupingKind$)) {
    $n_Lpresto_types$GroupingKind$ = new $c_Lpresto_types$GroupingKind$();
  }
  return $n_Lpresto_types$GroupingKind$;
}
export { $m_Lpresto_types$GroupingKind$ as $m_Lpresto_types$GroupingKind$ };
/** @constructor */
function $c_Lpresto_types$GroupingKind$$anon$17(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$GroupingKind$$anon$17 as $c_Lpresto_types$GroupingKind$$anon$17 };
$p = $c_Lpresto_types$GroupingKind$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingKind$$anon$17;
/** @constructor */
function $h_Lpresto_types$GroupingKind$$anon$17() {
}
export { $h_Lpresto_types$GroupingKind$$anon$17 as $h_Lpresto_types$GroupingKind$$anon$17 };
$h_Lpresto_types$GroupingKind$$anon$17.prototype = $p;
$p.a1 = (function(a) {
  $m_Lpresto_types$GroupingKind$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Json$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Json$JString(a.l());
});
var $d_Lpresto_types$GroupingKind$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingKind$$anon$17, "presto.types$GroupingKind$$anon$17", ({
  a0l: 1,
  a: 1,
  k: 1
}));
export { $d_Lpresto_types$GroupingKind$$anon$17 as $d_Lpresto_types$GroupingKind$$anon$17 };
/** @constructor */
function $c_Lpresto_types$GroupingKind$$anon$18(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$GroupingKind$$anon$18 as $c_Lpresto_types$GroupingKind$$anon$18 };
$p = $c_Lpresto_types$GroupingKind$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingKind$$anon$18;
/** @constructor */
function $h_Lpresto_types$GroupingKind$$anon$18() {
}
export { $h_Lpresto_types$GroupingKind$$anon$18 as $h_Lpresto_types$GroupingKind$$anon$18 };
$h_Lpresto_types$GroupingKind$$anon$18.prototype = $p;
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cy = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cq = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.cr = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cI = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cz = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  $m_Lpresto_types$GroupingKind$();
  var this$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sr_RichInt(x.a9K);
  var y$1 = y.a9K;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$Int$();
  var x$2 = this$3.uF;
  return ((x$2 === y$1) ? 0 : ((x$2 < y$1) ? (-1) : 1));
});
var $d_Lpresto_types$GroupingKind$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingKind$$anon$18, "presto.types$GroupingKind$$anon$18", ({
  a0m: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$GroupingKind$$anon$18 as $d_Lpresto_types$GroupingKind$$anon$18 };
var $t_Lpresto_types$GroupingKind$__intimacao = null;
function $u_Lpresto_types$GroupingKind$__intimacao(x) {
  $t_Lpresto_types$GroupingKind$__intimacao = x;
}
export { $t_Lpresto_types$GroupingKind$__intimacao as $t_Lpresto_types$GroupingKind$__intimacao, $u_Lpresto_types$GroupingKind$__intimacao as $u_Lpresto_types$GroupingKind$__intimacao };
var $t_Lpresto_types$GroupingKind$__movimentacao = null;
function $u_Lpresto_types$GroupingKind$__movimentacao(x) {
  $t_Lpresto_types$GroupingKind$__movimentacao = x;
}
export { $t_Lpresto_types$GroupingKind$__movimentacao as $t_Lpresto_types$GroupingKind$__movimentacao, $u_Lpresto_types$GroupingKind$__movimentacao as $u_Lpresto_types$GroupingKind$__movimentacao };
var $t_Lpresto_types$GroupingKind$__protocolo = null;
function $u_Lpresto_types$GroupingKind$__protocolo(x) {
  $t_Lpresto_types$GroupingKind$__protocolo = x;
}
export { $t_Lpresto_types$GroupingKind$__protocolo as $t_Lpresto_types$GroupingKind$__protocolo, $u_Lpresto_types$GroupingKind$__protocolo as $u_Lpresto_types$GroupingKind$__protocolo };
var $t_Lpresto_types$GroupingKind$__copia = null;
function $u_Lpresto_types$GroupingKind$__copia(x) {
  $t_Lpresto_types$GroupingKind$__copia = x;
}
export { $t_Lpresto_types$GroupingKind$__copia as $t_Lpresto_types$GroupingKind$__copia, $u_Lpresto_types$GroupingKind$__copia as $u_Lpresto_types$GroupingKind$__copia };
//# sourceMappingURL=presto.types$-Grouping-Kind$.js.map
